import { cn } from "@/lib/utils"

const sizes = {
  sm: {
    container: "w-4 h-4",
    border: "border-2",
  },
  md: {
    container: "w-10 h-10",
    border: "border-4",
  },
  lg: {
    container: "w-16 h-16",
    border: "border-4",
  },
} as const

interface SpinnerProps {
  size?: keyof typeof sizes
  className?: string
}

export function Spinner({ size = "md", className }: SpinnerProps) {
  const { container, border } = sizes[size]

  return (
    <div className={cn("relative", container, className)}>
      <div className={cn("absolute inset-0 rounded-full border-muted", border)} />
      <div className={cn("absolute inset-0 rounded-full border-primary border-t-transparent animate-spin", border)} />
    </div>
  )
}
